/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { getUserTokenExpiration } from '../utils';

interface TotalStatsModal {
  tokenExpirationTime: number;
}
const initialState: TotalStatsModal = {
  tokenExpirationTime: getUserTokenExpiration() || 0,
};

export const tokenExpirationDateSlice = createSlice({
  name: 'tokenExpirationDateState',
  initialState,
  reducers: {
    setTokenExpirationDate: (state, action: PayloadAction<number>) => {
      state.tokenExpirationTime = action.payload;
    },
  },
});

export const { setTokenExpirationDate } = tokenExpirationDateSlice.actions;

export default tokenExpirationDateSlice.reducer;
